export default __webpack_public_path__ + "static/media/Oily Skin Kit 1.02a4d257.jpg";